import React from 'react';
import PropTypes from 'prop-types';

import { utteranceType } from 'types';
import UtteranceItem from './components/UtteranceItem';

import './style.scss';

const UtterancesList = ({ utterances, onDelete }) => (
  <div data-test="utterances-list" styleName="list">
    {utterances.map((utterance, index) => (
      <UtteranceItem
        key={utterance.id}
        index={index}
        utterance={utterance}
        onDelete={onDelete}
      />
    ))}
  </div>
);

UtterancesList.propTypes = {
  utterances: PropTypes.arrayOf(utteranceType).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default UtterancesList;
